import React from 'react'; 
import MovieTimesPeriodeDaysItemsDesktop from './MovieTimesPeriodeDaysItemsDesktop'
import getTranslationTime from '../functions/getTranslationTime';
import Translation from '../General/Translation';
import getPerformancesIntervallByCinema from '../functions/getPerformanceIntervallByCinema';
import getDayKey from '../functions/getDayKey';
import getMomentNow from '../functions/getMomentNow';
import { useIsOverflow } from '../functions/useIsOverflow';
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { FRONT, PROGRAM_CINEMAS, TRANSLATION } from '../constants/state';
import getData from '../functions/getData';


const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION),
    cinemas: getData(state, PROGRAM_CINEMAS)
})


const getSortedCinemasObjects = (cinemaPk, cinemas) => {
    const sortedTheatres = cinemaPk.sort(function(a, b) {
        const cinemaA = cinemas[a]
        const cinemaB = cinemas[b]

        const aName = cinemaA.nameDisplay
        const bName = cinemaB.nameDisplay
        
        return bName > aName ? -1 : bName < aName ? 1 : 0
    })

    return sortedTheatres
}

const MovieTimesCinemaContainer = ({ 
    movieId, 
    movieTitle, 
    performances, 
    activePerformance, 
    translation, 
    today,
    alternativeLinks,
    scrollToPosition, 
    onOpenIframe, 
    queryStringValues,
    cinemaDataFront,
    cinemas
}) => {
    const { timezone } = translation
    const {show_performancePrice} = cinemaDataFront
    const dateNow = getMomentNow(timezone)

    const cinemasData = getPerformancesIntervallByCinema(performances, today, dateNow, timezone, queryStringValues)
    if(!cinemasData) {
        return ''
    }

    const ref = React.useRef();
    const refInner = React.useRef();
    const scrollingData = useIsOverflow(ref, refInner);

    const { isOverflow, needsScrollingLeft, needsScrollingRight } = scrollingData
    const { dayIntervallObject, dayIntervallKeys, cinemasObjects } = cinemasData        

    const todayKey = getDayKey(today)
    const className = 'movie-times-desktop movie-times-days-' + dayIntervallKeys.length
    const sortedObjectKeys = getSortedCinemasObjects(Object.keys(cinemasObjects), cinemas)

    return (
        <div className={className} ref={ref}>
            {isOverflow && needsScrollingLeft && <SliderArrowPrev onClick={() => {ref.current.scrollBy({
                top: 0,
                left: -160,
                behavior: 'smooth'
            })}}/>}
            <div className="movie-times-grid">
                {dayIntervallKeys.sort().map((dayKey, index) => {
                    const isToday = todayKey === dayKey 
                    const dayFormarted = isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, dayKey)
                    const additionalClass = isToday ? "accent-color-background" : "accent-color-background-dark"
                    const noPerformancesClass = isToday ? '' : (dayIntervallObject[dayKey][0] ? '' : ' no-performances')

                    return <div className={"date text-light " + additionalClass + noPerformancesClass} key={index}>{dayFormarted}</div>
                })}
            </div>


            {sortedObjectKeys.map((cinemaPk, index) => {
                const cinemaObjectData = cinemasObjects[cinemaPk]
                const { dayIntervall } = cinemaObjectData
                const cinema = cinemas[cinemaPk]
                const cinemaAlternativeLink = alternativeLinks && alternativeLinks[cinemaPk] ? alternativeLinks[cinemaPk] : null

                if(!cinema) {
                    return ''
                }

                const { nameDisplay } = cinema

                if(dayIntervall.length > 0) {
                    return ''
                }

                return (
                    <div key={index} className='thater-and-performance-container' ref={refInner}>
                        <div className="theatre-and-attributes-wrapper">
                            <div className="title-xlarge-theatre theatre">{nameDisplay}</div>
                        </div>

                            <div className="movie-times-grid">
                                {dayIntervallKeys.sort().map((dayKey, index) => {
                                    const performances = dayIntervall[dayKey]
                                    const isToday = todayKey === dayKey 
                                    const additionalClass = isToday ? "is-today" : ""

                                    return (
                                        <div key={index} className={'performances-wrapper ' + additionalClass}>
                                            {performances && <MovieTimesPeriodeDaysItemsDesktop
                                                movieId={movieId}
                                                movieTitle={movieTitle}
                                                dateNow={dateNow}
                                                performances={performances}
                                                showPerformancePrice={show_performancePrice}
                                                alternativeLink={cinemaAlternativeLink}
                                                activePerformance={activePerformance}
                                                showAttributes={true}
                                                hideTheatres={false}
                                                translation={translation}
                                                scrollToPosition={scrollToPosition}
                                                onOpenIframe={onOpenIframe}
                                            />}
                                        </div>  
                                    )

                                })}
                            </div>
                        
                    </div>
                )
            })}
            {isOverflow && needsScrollingRight && <SliderArrowNext onClick={() => {
                ref.current.scrollBy({
                    top: 0,
                    left: +160,
                    behavior: 'smooth'
                })}}/>}
        </div>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesCinemaContainer)